import { Injectable } from '@angular/core';

import { Action, select, Store } from '@ngrx/store';

import * as fromRoles from './roles.reducer';
import * as RolesSelectors from './roles.selectors';
import { loadRoles } from './roles.actions';
import { map } from 'rxjs/operators';
import { RoleAuthTarget } from '@boma/client-shared';

@Injectable()
export class RolesFacade {
  loaded$ = this.store.pipe(select(RolesSelectors.getRolesLoaded));
  allRoles$ = this.store.pipe(select(RolesSelectors.getAllRoles));
  selectedRoles$ = this.store.pipe(select(RolesSelectors.getSelectedRole));

  assignedAdminRoless$ = this.store.pipe(
    select(RolesSelectors.getAssignedAdminRoles)
  );

  customRoles$ = this.store.pipe(
    select(RolesSelectors.getAllRoles),
    map((roles) => roles.filter((r) => !!r.entityId))
  );

  customLocationRoles$ = this.store.pipe(
    select(RolesSelectors.getLocationRoles),
    map((roles) => roles.filter((r) => !!r.entityId))
  );

  customEntityRoles$ = this.store.pipe(
    select(RolesSelectors.getEntityRoles),
    map((roles) => roles.filter((r) => !!r.entityId))
  );
  presetEntityRoles$ = this.store.pipe(
    select(RolesSelectors.getEntityRoles),
    map((roles) => roles.filter((r) => !r.entityId))
  );
  locationRoles$ = this.store.pipe(select(RolesSelectors.getLocationRoles));
  vehicleRoles$ = this.store.pipe(select(RolesSelectors.getVehicleRoles));

  isCreatingOrUpdatingRoles$ = this.store.select(
    RolesSelectors.isModifyingRoles
  );

  isApplyingRoles$ = this.store.select(RolesSelectors.isApplyingRoles);

  constructor(private store: Store<fromRoles.RolesPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadEntityRoles() {
    this.dispatch(loadRoles({ target: RoleAuthTarget.Entity }));
  }

  loadLocationRoles() {
    this.dispatch(loadRoles({ target: RoleAuthTarget.Location }));
  }
}
